import ActivateCard from "./ActivateCard";
export default ActivateCard;
